import { useEffect, useRef, useCallback } from 'react';

export const useIdleLogout = ({ timeout = 5 * 60 * 1000, onIdle, isAuthenticated }) => {
  const timerRef = useRef(null);
  const onIdleRef = useRef(onIdle);
  onIdleRef.current = onIdle;

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    if (isAuthenticated) timerRef.current = setTimeout(() => onIdleRef.current(), timeout);
  }, [isAuthenticated, timeout]);

  useEffect(() => {
    if (!isAuthenticated) {
      if (timerRef.current) clearTimeout(timerRef.current);
      return;
    }

    const events = ['mousedown', 'keypress', 'scroll', 'wheel', 'touchstart', 'click', 'keydown'];
    const handleActivity = () => resetTimer();

    resetTimer();
    events.forEach(e => document.addEventListener(e, handleActivity, true));

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach(e => document.removeEventListener(e, handleActivity, true));
    };
  }, [isAuthenticated, resetTimer]);
};
